<template>
  <div>
    <Head />

    <!-- 網站導覽 -->
    <div class="wrapper api form">
      <section class="breadcrumb-box">
        <div class="container">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link to="/">首頁</router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                TEST
              </li>
            </ol>
          </nav>
        </div>
      </section>
      <section class="main">
        <div class="container">
          <h1>TEST</h1>
          <ul class="text-box">
            <li class="text">
              <div class="font-box">
                <div class="container">
                  <div class="box">
                    <div class="option-box">
                      <label for="name" style="min-width: 150px">姓名</label>
                      <input
                        id="name"
                        v-model="name"
                        class=""
                        type="text"
                        placeholder="請輸入申請人姓名"
                      />
                    </div>
                    <div class="option-box">
                      <label for="email" style="min-width: 150px">E-Mail</label>
                      <input
                        id="email"
                        v-model="email"
                        class=""
                        type="text"
                        placeholder="請輸入聯絡E-Mail"
                      />
                    </div>
                    <div class="option-box">
                      <label for="phone" style="min-width: 150px">電話</label>
                      <input
                        id="phone"
                        v-model="phone"
                        class=""
                        type="text"
                        placeholder="請輸入聯絡電話"
                      />
                    </div>
                    <div class="option-box">
                      <label for="company" style="min-width: 150px"
                        >公司或機構名稱</label
                      >
                      <input
                        id="company"
                        v-model="company"
                        class=""
                        type="text"
                        placeholder="請輸入公司或機構名稱"
                      />
                    </div>
                  </div>
                  <div class="box">
                    <h2>驗證碼</h2>
                    <div class="form-group">
                      <div class="code-box">
                        <input
                          class="form-control"
                          placeholder="驗證碼"
                          v-model="identifyCode_input"
                        />
                        <div class="code">
                          <Sidentify :identifyCode="identifyCode"></Sidentify>
                          <a href="javascript:void(0)" @click="refreshCode()"
                            ><img src="/img/icon-rotate.svg" alt=""
                          /></a>
                          <a href="javascript:void(0)" @click="playCode()"
                            ><img src="/img/icon-voice.svg" alt=""
                          /></a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="btn-box">
                    <button
                      type="button"
                      :disabled="identifyCode != identifyCode_input"
                      :style="
                        identifyCode != identifyCode_input
                          ? 'cursor: no-drop;'
                          : ''
                      "
                      @click="SendApply"
                    >
                      送　出
                    </button>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </section>
    </div>
    <!-- wrapper -->

    <Footer />
  </div>
</template>
<script>
// @ is an alias to /src
import Head from "@/components/Head.vue";
import Footer from "@/components/Footer.vue";

import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import AES from "@/utils/aes.js";
import Validate from "@/utils/validate.js";
import { VueRecaptcha } from "vue-recaptcha";
import Sidentify from "@/components/Identify";

export default {
  name: "Form",
  components: {
    Head,
    Footer,
    VueRecaptcha,
    Sidentify,
  },
  data() {
    return {
      name: "",
      email: "",
      phone: "",
      company: "",
      appName: "",
      appUrl: "",
      agreeReg: "",
      Verify: false,
      identifyCode: "0511",
      identifyCode_input: "",
      identifyCodes: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
      identifyCode_sound: ["0.mp3", "5.mp3", "1.mp3", "1.mp3"],
      num: 0,
    };
  },
  created: function () {
    // Vue.axios
    //   .get(
    //     this.$store.state.src +
    //       this.$store.state.subDirectory +
    //       "/Html/CaseAdd",
    //     {
    //       params: {
    //         CTIId: this.$route.params.CTIId,
    //       },
    //     }
    //   )
    //   .then((response) => {
    //     this.CaseAddData = response.data;
    //     if (this.CaseAddData.CaseType.VerifiedType != 1) {
    //       this.Sugg_ReplyType = this.CaseAddData.CaseType.VerifiedType;
    //     }
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
    this.refreshCode();
  },
  mounted: function () {
    // API說明 按鈕切換
    $(".api .main .btn-box li").eq(0).addClass("active");
    $(".api .main .text-box .text").eq(0).addClass("show");

    $(".api .main .btn-box li").click(function () {
      var N = $(this).index();

      $(".api .main .btn-box li").removeClass("active");
      $(this).addClass("active");

      $(".api .main .text-box .text").removeClass("show");
      $(this).parents(".btn-box").siblings().children().eq(N).addClass("show");
    });
  },
  methods: {
    SendApply() {
      if (this.name == "") {
        Swal.fire({
          title: "錯誤",
          text: "請輸入姓名",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
          heightAuto: false,
        });
        return;
      }
      if (this.email == "") {
        Swal.fire({
          title: "錯誤",
          text: "請輸入E-Mail",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
          heightAuto: false,
        });
        return;
      } else if (!Validate.reg_email(this.email)) {
        Swal.fire({
          title: "錯誤",
          text: "E-Mail格式錯誤",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
          heightAuto: false,
        });
        return;
      }
      if (this.phone == "") {
        Swal.fire({
          title: "錯誤",
          text: "請輸入電話",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
          heightAuto: false,
        });
        return;
      }
      if (this.company == "") {
        Swal.fire({
          title: "錯誤",
          text: "公司或機構名稱",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
          heightAuto: false,
        });
        return;
      }
      if (this.appName == "") {
        Swal.fire({
          title: "錯誤",
          text: "應用程式名稱",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
          heightAuto: false,
        });
        return;
      }
      if (this.appUrl == "") {
        Swal.fire({
          title: "錯誤",
          text: "應用程式URL",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
          heightAuto: false,
        });
        return;
      }
      if (this.agreeReg != "1") {
        Swal.fire({
          title: "錯誤",
          text: "請勾選同意使用條款",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
          heightAuto: false,
        });
        return;
      }
      // 顯示請稍候
      Swal.fire({
        title: "請稍候...",
        allowOutsideClick: false,
        showConfirmButton: false,
        heightAuto: false,
        willOpen: function () {
          Swal.showLoading();
        },
      });
      // 開始送出
      let that = this;
      $.ajax({
        url:
          that.$store.state.src +
          that.$store.state.subDirectory +
          "/Html/ApiApply",
        type: "post",
        data: {
          name: that.name,
          email: that.email,
          phone: that.phone,
          company: that.company,
          appName: that.appName,
          appUrl: that.appUrl,
          agreeReg: that.agreeReg,
        },
        dataType: "json",
        error: function () {},
        success: function (res) {
          // 判斷結果
          if (res.ok) {
            Swal.fire({
              title: "送出成功",
              text: "您的填寫順序為:" + res.Number,
              icon: "success",
              allowOutsideClick: false,
              confirmButtonText: "確定",
              heightAuto: false,
              willClose: () => {
                location.reload();
              },
            });
          } else if (res.error) {
            Swal.fire({
              title: "錯誤",
              text: res.error,
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: "確定",
              heightAuto: false,
            });
          }
        },
      });
    },
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        var code =
          this.identifyCodes[this.randomNum(0, this.identifyCodes.length)];
        this.identifyCode += code;
        this.identifyCode_sound[i] = code + ".mp3";
      }
    },
    playCode() {
      var sound_path = "/voice/numvoice/zh";
      var audio = new Audio(
        sound_path + "/" + this.identifyCode_sound[this.num]
      );
      audio.play();
      let that = this;
      audio.addEventListener(
        "ended",
        function () {
          that.num++;
          if (that.num < 4) that.playCode();
          if (that.num >= 4) that.num = 0;
        },
        false
      );
    },
  },
};
</script>

